import './LangButton.css';
import React from 'react';
// import axios from 'axios';
// import { Avatar } from 'antd';
import { chosen_lang, show_header, redir } from '../RecoilState';
import { useRecoilState } from 'recoil';

const SmallLangButton = ({ details }) => {

  // const [url, setUrl] = useState("");
  const [c_lang, setCLang] = useRecoilState(chosen_lang);
  // console.log(details);
  // console.log("langbutton.jsx");


  // useEffect(() => {
  //   axios.get(`wp/v2/media/${details.flag}`)
  //     .then((response) => {
  //       // console.log(response.data.source_url);
  //       setUrl(response.data.source_url);
  //     })
  //     .catch((err) => { console.log(err); })
  // }, [])

  const updateLang = () => {
    // console.log(details.code);
    setCLang({
      language: details.language,
      code : details.code,
      flag : details.flag,
    });
  }
  // console.log(c_lang);

  return (
    <>
      <button className="sm-lang-button" onClick={updateLang}>
        <img src={require(`../assets/${details.flag}`)} width="45" />
        <h2 className="text-base">{details.language}</h2>
      </button>
    </>
  )
}

export default SmallLangButton